import { Flex, Heading, Text } from "@aws-amplify/ui-react";
import { MdCheckCircleOutline } from "react-icons/md";
import { theme } from "../../theme";

const SECTION_WIDTH = 1250;

export default function ListSection({
  title,
  items,
}: {
  title: string;
  items: { text: string }[];
}) {
  return (
    <Flex
      direction="column"
      padding="20px"
      borderRadius="10px"
      marginTop="40px"
      alignItems={"center"}
    >
      <Flex width={"100%"} direction={"column"}>
        <Heading level={2} marginBottom="20px" fontWeight={600}>
          {title}
        </Heading>

        <Flex direction="column" maxWidth={SECTION_WIDTH}>
          {items.map((item) => (
            <Flex direction={"row"} alignItems={"center"} gap={32}>
              <Flex>
                <MdCheckCircleOutline
                  size={32}
                  color={theme.success}
                ></MdCheckCircleOutline>
              </Flex>
              <Text fontSize={20}>{item.text}</Text>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
}
